/**
 * Words the app puts in the user's mouth: a suggestion to press, a message started for them. They are
 * said in the language the user speaks to their agents in — the one chosen in Settings, else the main
 * agent's, else the browser's. The screens themselves are in English.
 */
import type { AgentKind } from './data'
import { useDemo } from './store'

type Lang = 'Türkçe' | 'English'
export function spoken(): Lang {
  const s = useDemo.getState()
  const set = s.settings?.agentLang
  if (set === 'Türkçe' || set === 'English') return set
  const lead = s.agents.find((a) => a.kind === 'lead')?.lang
  if (lead === 'Türkçe' || lead === 'English') return lead
  return typeof navigator !== 'undefined' && navigator.language?.toLowerCase().startsWith('tr') ? 'Türkçe' : 'English'
}
const tr = () => spoken() === 'Türkçe'

/** What an agent's empty page offers to start with. */
export const quick = (kind: AgentKind): string[] =>
  kind === 'lead'
    ? tr()
      ? ['Portföyüm nasıl?', 'Bugün piyasada ne var?', 'Bu haftanın takvimi', 'Açık emirlerim neler?']
      : ['How is my portfolio?', 'What is moving in the market today?', 'This week’s calendar', 'What orders do I have open?']
    : tr()
      ? ['Kendini tanıt', 'Bugün ne yapabilirsin?', 'Bunu her sabah kontrol et…']
      : ['Introduce yourself', 'What can you do today?', 'Check this every morning…']
export const groupQuick = (): string[] => (tr() ? ['Herkes ne üzerinde çalışıyor?', 'Bu işi aranızda paylaşın…', 'Bugünün özeti'] : ['What is everyone working on?', 'Share this job between you…', 'Today’s summary'])

/** Messages started for the user (they finish and send them). */
export const starts = {
  aboutStock: (symbol: string) => (tr() ? `${symbol} ne durumda?` : `How is ${symbol} doing?`),
  workerPlan: () => (tr() ? 'Bana bir worker planı hazırla: ' : 'Draw up a worker plan for me: '),
  replan: (name: string) => (tr() ? `${name} planını yeniden kuralım: ` : `Let us redo the plan of ${name}: `),
  editWatch: (name: string, scan: boolean) => (tr() ? `${scan ? 'Taramayı' : 'İzleyiciyi'} düzenle (${name}): ` : `Change the ${scan ? 'scan' : 'watcher'} (${name}): `),
  learned: (name: string) => (tr() ? `${name} işleminden ne öğrendik?` : `What did we learn from the ${name} trade?`),
}
